/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  TestSQLHelpers,
  TestSQLHelpersInterface,
} from "../../../contracts/test/TestSQLHelpers";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "input",
        type: "string",
      },
    ],
    name: "quote",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "columns",
        type: "string",
      },
      {
        internalType: "string[]",
        name: "values",
        type: "string[]",
      },
    ],
    name: "toBatchInsert",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "schema",
        type: "string",
      },
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
    ],
    name: "toCreateFromSchema",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "filters",
        type: "string",
      },
    ],
    name: "toDelete",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "columns",
        type: "string",
      },
      {
        internalType: "string",
        name: "values",
        type: "string",
      },
    ],
    name: "toInsert",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
    ],
    name: "toNameFromId",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "tableId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "setters",
        type: "string",
      },
      {
        internalType: "string",
        name: "filters",
        type: "string",
      },
    ],
    name: "toUpdate",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestSQLHelpersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestSQLHelpersConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestSQLHelpers__factory extends ContractFactory {
  constructor(...args: TestSQLHelpersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TestSQLHelpers> {
    return super.deploy(overrides || {}) as Promise<TestSQLHelpers>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TestSQLHelpers {
    return super.attach(address) as TestSQLHelpers;
  }
  override connect(signer: Signer): TestSQLHelpers__factory {
    return super.connect(signer) as TestSQLHelpers__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestSQLHelpersInterface {
    return new utils.Interface(_abi) as TestSQLHelpersInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestSQLHelpers {
    return new Contract(address, _abi, signerOrProvider) as TestSQLHelpers;
  }
}
